var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "changefirware" },
    [
      _c(
        "el-form",
        {
          ref: "updateData",
          attrs: {
            model: _vm.updateData,
            rules: _vm.rulesupdate,
            "status-icon": true,
            "show-message": false,
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "系统: ",
                "label-width": _vm.formLabelWidth,
                prop: "type",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.updateData.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.updateData, "type", $$v)
                    },
                    expression: "updateData.type",
                  },
                },
                _vm._l(_vm.system, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "任务类型: ",
                "label-width": _vm.formLabelWidth,
                prop: "taskType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.updateData.taskType,
                    callback: function ($$v) {
                      _vm.$set(_vm.updateData, "taskType", $$v)
                    },
                    expression: "updateData.taskType",
                  },
                },
                _vm._l(_vm.taskTypes, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-right": "8px" },
              attrs: {
                label: "语言: ",
                "label-width": _vm.formLabelWidth,
                prop: "lan",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "selectWidth",
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  on: {
                    focus: function ($event) {
                      return _vm.getLan()
                    },
                  },
                  model: {
                    value: _vm.updateData.lan,
                    callback: function ($$v) {
                      _vm.$set(_vm.updateData, "lan", $$v)
                    },
                    expression: "updateData.lan",
                  },
                },
                _vm._l(_vm.lanData, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { "padding-left": "8px" },
              attrs: { label: "版本号: ", "label-width": _vm.formLabelWidth },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.updateData.firmwareVersion,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "firmwareVersion", $$v)
                  },
                  expression: "updateData.firmwareVersion",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "dialogEditor",
              attrs: { "label-width": _vm.formLabelWidth, prop: "fixPoint" },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  staticStyle: { display: "none" },
                  attrs: {
                    action: "",
                    "http-request": _vm.to_upload_img,
                    "show-file-list": false,
                  },
                },
                [
                  _vm._v("\n        >\n        "),
                  _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon",
                    attrs: { id: "imgInput" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("quill-editor", {
                ref: "myQuillEditor",
                attrs: { options: _vm.editorOption, "show-word-limit": "" },
                model: {
                  value: _vm.updateData.fixPoint,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateData, "fixPoint", $$v)
                  },
                  expression: "updateData.fixPoint",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isDisable },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }